import { computed } from 'mobx';

import { ViewController } from '@estee/elc-service';

import { UserRepository } from '~repositories/UserRepository';

interface IUserSessionSuspenseViewController {
    userRepository: UserRepository;
}

export class UserSessionSuspenseViewController extends ViewController {
    private userRepository: UserRepository;

    constructor({ userRepository }: IUserSessionSuspenseViewController) {
        super();
        this.userRepository = userRepository;
    }

    @computed
    public get data() {
        const { sessionResponse } = this.userRepository;

        return {
            sessionResponse
        };
    }

    loaded = async () => {
        await this.userRepository.loadSession();
    };
}
